import { getAttributeOrThrow } from '@/scripts/core/global'
import { UcoastEl } from '@/scripts/core/UcoastEl'
import { mediaLoader } from '@/scripts/core/global'

export class TaggedBlogSlider extends UcoastEl {
	static htmlSelector = 'tagged-blog-slider'
	blogHandle: string
	category: string
	constructor() {
		super()
		this.blogHandle = getAttributeOrThrow('data-uc-blog-handle', this)
		this.category = getAttributeOrThrow('data-uc-category', this)
	}

	override connectedCallback() {
		const fetchUrl = `/blogs/${this.blogHandle}/tagged/${this.category}?sections=tagged-blog-slider`

		fetch(fetchUrl)
			.then((response) => response.json())
			.then((json) => {
                const html = json['tagged-blog-slider']
                if (!html) {
                    console.log('HTML NOT FOUND')
                    this.remove()
                    return
                }


				if (html.trim().length) {
					this.innerHTML = html
					mediaLoader()
				}
			})
			.catch((e) => {
				console.error(e)
			})
	}
}
